/**
 * @module leavePolicy
 * @description A list of leavePolicy
 */

export const leavePolicy = ['none', 'annual', 'payoff'] as const;
export type LeavePolicy = (typeof leavePolicy)[number];
